export default __webpack_public_path__ + "static/media/heroku.73be03b3.svg";